import Hero from "../Components/Hero";
import Navbar from "../Components/Navbar";
import AboutImg from "../Assets/night.jpg";
import Footer from "../Components/Footer";
import Trip from "../Components/Trip";
import "../Components/TripStyles.css";
function Service() {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={"https://media.istockphoto.com/id/1393568296/photo/the-magically-forested-view-of-singaporean-green-corridors-and-keppel-bay-from-henderson-wave.webp?b=1&s=170667a&w=0&k=20&c=nCRIbdgM4sQEJ4F6L_gTPyMGw2-7pYjtvR-d79YMw1Q="}
        title="Service"
        btnClass="hide"
      />
      <Trip />
      <Footer />
    </>
  );
}

export default Service;
